// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as PnmIntShiftReqLocationDetailsApiModel$PorterinFeature from "../../api-model/PnmIntShiftReqLocationDetailsApiModel.mjs";

function apiModelToState(model) {
  return {
          sr_external_id: model.shifting_requirement.external_id
        };
}

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(PnmIntShiftReqLocationDetailsApiModel$PorterinFeature.t_decode(json), "PnmIntShiftReqLocationDetailsEntityMapper.res");
  return {
          sr_external_id: model.shifting_requirement.external_id
        };
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
